import { parseGameEventTime } from 'modules/games/utils/games-utils';
import { GameEvent } from '../interfaces/GameDetails';
import { GameEventDTO } from '../interfaces/GameEventDTO';

export function mapGameEvent(dto: GameEventDTO): GameEvent {
  const {
    minutes,
    extraMinutes,
  } = parseGameEventTime(dto.seconds!, dto.period!);

  return {
    id: dto.id || Date.now(),
    teamId: dto.teamId,
    type: dto.type,
    period: dto.period,
    seconds: dto.seconds,
    minutes,
    extraMinutes,
    playerIds: dto.firstPlayerId
      ? dto.secondPlayerId ? [dto.firstPlayerId, dto.secondPlayerId] : [dto.firstPlayerId]
      : [],
  } as GameEvent;
}